var datatables = $('.datatable:not(.ignore)');
if (datatables.length > 0) {
    datatables.each(function () {
        if (!$.fn.DataTable.isDataTable($(this))) {
            $(this).DataTable({
                responsive: true,
            });
        }
    });
}

// Trigger resize event after navigation tab change
$(document).on('shown.bs.tab', '[data-bs-toggle="tab"], [data-bs-toggle="pill"]', function () {
    $(window).trigger('resize');
});
